<div>
  <gen-rich-notes [title]="formConfig[0]['title']" (notesChanged)="notesChanged($event)" [notes]="data"></gen-rich-notes>
</div>
